<template>
  <div class="column">
      <div class="banner"><img src="./banner-column-new.jpg" alt="" width="100%"></div>
      <div class="column-main-bg">
        <div class="column-main">
            <p class="title">亚商30年历史照片回廊</p>
            <div class="swiper">
                <swiper :options="swiperOption">
                    <swiper-slide v-for="(slide, index) in slidePic" :key="index">
                        <img :src="slide" alt="" >
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                        <!-- <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div> -->
                </swiper>
            </div>
            <div class="content">
                <table>
                    <tr v-for="(item, index) in historyList" :key="index">
                        <!-- <td class="year">{{item.year}}</td> -->
                        <td class="introduce">{{item.introduce}}</td>
                    </tr>
                </table>
            </div>
        </div>
      </div>
      <go-top></go-top>
  </div>
</template>

<script>
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'
import pic7 from './pic7.jpg'
import pic8 from './pic8.jpg'
import pic9 from './pic9.jpg'
import goTop from "../../common/go-top.vue";
export default {
  name: 'SpecialColumn',
  components: {
    goTop
  },
  data () {
      return {
          slidePic: [
              pic1,pic2,pic3,pic4,pic5,pic6,pic7,pic8,pic9,
          ],
          swiperOption: {
            pagination : {
                el: '.swiper-pagination',
                clickable: true,
                // bulletActiveClass: 'my-bullet-active'
            },
            autoplay: {delay: 4000},
            loop: true,
            loopFillGroupWithBlank: true,
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
          },
          historyList: [
              {
                  year: '1988年',
                  introduce: '1988年，在汪道涵老先生的指示下，时任华东师范大学国际金融系教授的陈琦伟先生成立了亚商的前身：“亚洲研究所”，专注于研究如何将当年“亚洲四小龙”经济发展的成功经验借鉴到改革开放初期的中国，同时也将自己多年积累下来的学术理论和心得在市场上进行实践。三十年后的今天，亚商已从当初的那个“文科教授实验室”逐渐成长为集资产管理、投资、咨询及行业研究为一体的精品金融服务平台。'
              },
              {
                  year: '',
                  introduce: '亚商的三十年也正是中国资本市场和民营企业经济迅速腾飞的三十年。亚商不仅有幸全程见证和参与，并且一直在用自身实际行动引领行业风气之先。无论是最初作为全国最早股评周刊的《壹周投资》；还是1993年在中国石破天惊的最早四个上市公司控股权争夺案例中连续担任了三个案例的财务顾问；还是1995年因预见到中国持续的市场化趋势而必然激发越来越多的兼并收购活动，因此牵头召开中国首次“企业兼并收购讨论会”，并在此后身体力行策划了上房一嘉丰、中远一众城等一系列大型企业的并购活动；还是自1999年起与《中国证券报》共同发起“中国最具潜力的上市公司”评选及论坛活动，并以此为契机拓展了亚商的战略管理咨询业务；还有自2001年始开始在咨询主业支持下涉足风险投资领域，发起成立“亚商资本”并先后管理了多支人民币基金类的投资公司，形成了咨询加投资的稳定主业模式和独特的核心竞争力，这些都显示了亚商对中国资本市场的前瞻性，以及敢于开拓创新的企业家精神。'
              },
              {
                  year: '1993年',
                  introduce: ' 展望未来，随着资本市场监管政策的日趋严谨完善，国家对于金融去杠杆以及服务实体企业的决心愈发明显。与此同时，大数据、区块链、人工智能等新科技的崛起也将对资管行业带来前所未有的冲击和机遇。鉴于此，亚商集团于2015年重启了老品牌亚商资管并引入多位国内一流企业家和投资家作为战略股东，以上市公司龙头企业战略价值管理为核心切入点，拥抱“大资管”时代。另外，公司与时俱进地成立了金融科技部，致力于研究如何通过科技手段提升并优化传统资管业务。'
              },
              {
                  year: '1995年',
                  introduce: '下一个三十年，亚商人定不忘初心，将与中国的优秀企业和资本市场共同续写精彩的篇章。'
              }
          ]
      }
  }
}
</script>

<style scoped>
.banner{
  width: 100%;
}
.column-main-bg{
    padding: 48px 0 75px 0;
    box-sizing: border-box;
    /* background: url('./bg.jpg') no-repeat center top; */
    /* background-size: 100%; */
}
.column-main{
    width: 1180px;
    margin: 0 auto;
    background: #fff;
    padding: 80px 76px;
    box-sizing: border-box;
    border: 1px solid #CED7E2;
}
.column-main .title{
    color: #333;
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 35px;
    text-align: left;
}
.column-main .introduce{
    color: #666666;
    line-height: 32px;
    text-align: justify;
    padding-bottom: 25px;
    text-indent: 2em;
}
.column{
    min-width: 1200px;
}
.column .content{
    padding-top: 60px;
}
.column .swiper{
    padding: 0 40px;
}
.column table{
    width: 100%;
    font-size: 18px;
}
.column table .year{
    color: #003B83;
    font-weight: 600;
    font-size: 20px;
    text-align: left;
    width: 100px;
}
.column table tr:last-child td:last-child{
    /* font-weight: 600; */
    /* font-size: 20px; */
}
</style>





// WEBPACK FOOTER //
// src/components/specialColumn/SpecialColumn.vue